/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Details
 */
export interface Details {
}

/**
 * Check if a given object implements the Details interface.
 */
export function instanceOfDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DetailsFromJSON(json: any): Details {
    return DetailsFromJSONTyped(json, false);
}

export function DetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Details {
    return json;
}

export function DetailsToJSON(value?: Details | null): any {
    return value;
}

